import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';
import classes from './IAndCArchiveServices.module.css';
import { pushToError } from '../../../../utils/common';
class IAndCArchiveServices extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    this.props.setCurrentRouteState('aa/services', 'I&C Archive');
    $('.' + classes.IAndCArchiveServices).load(
      '/html/angularContainer.html',
      () => {
        const url =
          'https://dls-dev.siemens.cloud/sp/sp.static/html/aaservicestest.html';
        axios
          .get(url, {
            headers: { Authorization: `Bearer ${this.props.settings.token}` },
          })
          .then(response => {
            $('#angularContainer').load(window.makeTextFile(response.data));
            this.setState({
              htmlApiLoading: false,
            });
          })
          .catch(err => {
            console.error(err);
            pushToError(this.props,this.state.pname,err,url);
          });
      }
    );
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading ? <LoadingScreen /> : null}
        <div className={classes.IAndCArchiveServices}></div>
      </React.Fragment>
    );
  }
}

export default IAndCArchiveServices;
